import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Photobooth from "@/pages/Photobooth";
import Gallery from "@/pages/Gallery";
import Downloads from "@/pages/Downloads";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Photobooth />} />
          <Route path="/galerija" element={<Gallery />} />
          <Route path="/prenosi" element={<Downloads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
